export * from './app-sidebar-minimizer.component';



// WEBPACK FOOTER //
// C:/repos/Tulaima/Tulaima-ng/src/app/components/app-sidebar-minimizer/index.ts